// Shown as "Total Pay" at the statement header — excluded from breakdown detail columns
export const FINAL_PAYOUT_KEY = "final_payout";

// Has dedicated payout_amount display — excluded from dynamic trace columns
export const COMMISSION_TRACE_KEY = "commission";

export const ICM_TAB = {
  technicians: "technicians",
  jobs: "jobs",
} as const;
export type IcmTab = (typeof ICM_TAB)[keyof typeof ICM_TAB];
